__turbopack_context__.v({
  "error": "TFW_Uq_error",
  "item-no-match": "TFW_Uq_item-no-match",
  "item-prompt": "TFW_Uq_item-prompt",
  "item-searching": "TFW_Uq_item-searching",
  "menu-title": "TFW_Uq_menu-title",
  "typeahead": "TFW_Uq_typeahead",
  "typeahead-error": "TFW_Uq_typeahead-error",
  "typeahead-item": "TFW_Uq_typeahead-item",
  "typeahead-item-active": "TFW_Uq_typeahead-item-active",
  "typeahead-item-menu": "TFW_Uq_typeahead-item-menu",
});
